import { ExtractComponentProp, FormValues } from '@approvalmax/types';
import { Form, RichEditor } from '@approvalmax/ui/src/components';
import { zodResolver } from '@hookform/resolvers/zod';
import { useSelector } from 'modules/react-redux';
import { changeRequestDescription } from 'pages/requestForm/actions/actions';
import { getShowValidationErrors } from 'pages/requestForm/selectors/pageSelectors';
import { memo, useEffect } from 'react';
import bemFactory from 'react-bem-factory';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { z } from 'zod';

import { messages } from './DescriptionSection.messages';
import { schema } from './DescriptionSection.schema';
import { DescriptionSectionProps } from './DescriptionSection.types';

const qa = bemFactory.qa('reqf-standalone-request-form');

export const DescriptionSection = memo<DescriptionSectionProps>((props) => {
    const { request } = props;

    const dispatch = useDispatch();
    const showErrors = useSelector(getShowValidationErrors);

    const form = useForm<z.infer<typeof schema>>({
        values: {
            description: request.details.description.value,
        },
        mode: 'onChange',
        resolver: zodResolver(schema),
    });

    const handleChange: ExtractComponentProp<typeof Form<FormValues<typeof form>>, 'onChange'> = (values, rootName) => {
        dispatch(changeRequestDescription({ value: values[rootName], errorMessages: null }));
    };

    useEffect(() => {
        showErrors && form.trigger();
    }, [showErrors, form]);

    return (
        <Form form={form} onChange={handleChange}>
            <RichEditor
                name='description'
                required
                label={messages.descriptionLabel}
                placeholder={messages.descriptionPlaceholder}
                size='small'
                dataQa={qa('request-description-editor')}
            />
        </Form>
    );
});

DescriptionSection.displayName = 'DescriptionSection';
